import { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useValidPassword } from "../hooks/useAuthHooks";
import Password from "../components/auth/password";
import { AuthContext } from "../context/authContext";
import { useLoading } from "../libs/loadingContext";
import { useTranslation } from "react-i18next";

export default function ChangePassword() {
  const [error, setError] = useState("");
  const {
    password: oldPassword,
    setPassword: setOldPassword,
    passwordIsValid: oldPasswordIsValid,
  } = useValidPassword("");
  const {
    password: newPassword,
    setPassword: setNewPassword,
    passwordIsValid: newPasswordIsValid,
  } = useValidPassword("");
  const navigate = useNavigate();
  const authContext = useContext(AuthContext);
  const { setLoading } = useLoading();
  const { t } = useTranslation();

  const changePassword = async () => {
    try {
      setLoading(true);
      await authContext.changePassword(oldPassword, newPassword);
      signOut();
    } catch (err) {
      if (err.message === "Incorrect username or password.") {
        setError(t("changePassword.errorMessage"));
      }
    } finally {
      setLoading(false);
    }
  };

  const signOut = async () => {
    try {
      await authContext.signOut(
        true,
        `${process.env.REACT_APP_AFTER_SIGNUP_URL}`
      );
    } catch (err) {
      if (err instanceof Error) {
        setError(err.message);
      }
    }
  };

  return (
    <>
      <div className="content-page">
        <Password
          passwordIsValid={oldPasswordIsValid}
          setPassword={setOldPassword}
          label={t("changePassword.oldPassword")}
          required={false}
          newPassword={false}
          visibleValidMessage={false}
        />
        {<div className="invalid-email">{error}</div>}
        <Password
          passwordIsValid={newPasswordIsValid}
          setPassword={setNewPassword}
          label={t("changePassword.newPassword")}
          required={false}
          newPassword={true}
        />
        <div className="forgot-password-request-btn">
          <button className="btn btn-default" onClick={() => changePassword()}>
            {t("changePassword.changePassword")}
          </button>
        </div>
      </div>
    </>
  );
}
